import {z} from "zod";

export const transferSchema = z.object({
  receiver_id: z.string().trim().min(3, "Ingresa un destinatario válido"),
  amount: z.coerce.number({message: "Monto inválido"}).positive("El monto debe ser mayor a 0"),
});

export type TransferFormInput = z.input<typeof transferSchema>;
export type TransferPayload = z.output<typeof transferSchema>;
